import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaMedicoOpcoes.vue?vue&type=template&id=409a84ad&scoped=true"
import script from "./ModalSolicitacaoCirurgiaMedicoOpcoes.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaMedicoOpcoes.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaMedicoOpcoes.vue?vue&type=style&index=0&id=409a84ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409a84ad",
  null
  
)

export default component.exports